@if (newAFIRiskCard) {
  <div class="new-template">
    <risk-card (onPolicyChange)="onPolicyChange($event)" [newCard]="true" class="risk-card">
      <div card-header class="card-header">
        <!-- Header Content -->
        <h2 class="policy-title" data-cy="umbrellaPolicyHeader">Umbrella</h2>
        <div class="pilet">
          <div class="pilet-text icon-complete" data-cy="umbrellaPolicyActiveHeader">Active</div>
        </div>
      </div>
      <div card-body class="card-body">
        <!-- Body Content -->
        <div class="policy-info">
          <div class="policy-details">
            <div class="policy-number">
              <span class="label" data-cy="umbrellaPolicyNumberTitle">Policy Number</span>
              <span class="value" data-cy="umbrellaPolicyNumber">{{
                policy | prettyPolicyNum
              }}</span>
            </div>
            <div class="effective-dates">
              <span class="label" data-cy="umbrellaPolicyEffectiveDatesTitle"
                >Effective Dates
                @if (policy.cancelDate) {
                  <div class="pilet">
                    <div class="pilet-text">Updated</div>
                  </div>
                }
              </span>
              @if (policy.cancelDate) {
                <span class="value" data-cy="umbrellaPolicyStartEndDate">
                  {{ policy?.periodStartDate | date: 'MM/dd/yyyy' }} -
                  {{ policy?.cancelDate | date: 'MM/dd/yyyy' }}</span
                >
              }
              @if (!policy.cancelDate) {
                <span class="value" data-cy="umbrellaPolicyStartEndDate">
                  {{ policy?.periodStartDate | date: 'MM/dd/yyyy' }} -
                  {{ policy?.periodEndDate | date: 'MM/dd/yyyy' }}</span
                >
              }
            </div>
          </div>
          <div class="underlying-policies">
            <span class="label" data-cy="umbrellaPolicyUnderlyingPoliciesTitle">
              Underlying Coverage
            </span>
            <ul class="policies-list">
              @for (policy of underLyingPolicies.underlyingPolicies; track policy) {
                <li>
                  <div class="policies-container">
                    @if (policy.productType === 'PersonalAuto') {
                      <ul class="policies-list">
                        @for (vehicle of policy.vehicles; track vehicle) {
                          <li>
                            <div class="policies-container">
                              <ds-underlying-policy-button
                                class="policy-button"
                                [productType]="policy.productType"
                                [productName]="vehicle.description"
                                [iconType]="vehicle.iconType"
                                [policyNumber]="policy.policyNumber"
                                [vehicleId]="vehicle.vehicleId"
                                data-cy="underlyingPolicyOne"
                              ></ds-underlying-policy-button>
                            </div>
                          </li>
                        }
                      </ul>
                    } @else {
                      <ds-underlying-policy-button
                        [productType]="policy.productType"
                        [productName]="policy.riskLocationAddress.addressLine1"
                        [iconType]="policy.iconType"
                        [policyNumber]="policy.policyNumber"
                        data-cy="underlyingPolicyTwo"
                      ></ds-underlying-policy-button>
                    }
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>
        <img class="policy-image" src="/assets/images/Umbrella-foodle.png" alt="Umbrella Policy" />
      </div>
      <div card-footer class="card-footer">
        <!-- Footer Content -->
        <a data-cy="get-documents-link" (click)="getDocuments()">
          <span class="icon-documents"></span>
          <span>Get Documents</span>
        </a>
        <a data-cy="request-policy-change-link" (click)="fileClaim()">
          <span class="icon-file-claim"></span>
          <span>File Claim</span>
        </a>
        <a data-cy="add-replace-vehicle-link" (click)="requestPolicyChange()">
          <span class="icon-refresh-reset"></span>
          <span>Request a Policy Update</span>
        </a>
      </div>
    </risk-card>
  </div>
} @else {
  <!-- Old Design Content -->
  <risk-card (onPolicyChange)="onPolicyChange($event)">
    <div header>
      <div class="column twelve md-six">
        <div class="double-icon">
          <i
            role="img"
            dsTabFocus
            [attr.aria-label]="policy.policyTypeDisplayName + ' Policy'"
            class="icon none xl-inline"
            [ngClass]="policy.iconType"
            data-cy="umbrellaPolicyTypeIcon"
          ></i>
        </div>
        <p class="heading" data-cy="umbrellaPolicyNumberHeader">Umbrella</p>
        <p class="heading-policy-vin" data-cy="umbrellaPolicyPrettyNumber">
          Policy: {{ policy | prettyPolicyNum }}
        </p>
      </div>
    </div>
    <div>
      <div class="column twelve">
        <div class="subsection">
          <p class="heading" data-cy="umbrellaPolicyAddressHeader">Address</p>
          <p class="address" data-cy="umbrellaPolicyFullAddress">
            {{ policy.policyAddress | address }}
          </p>
        </div>
      </div>
    </div>
  </risk-card>
}
